import useScript from 'react-script-hook';

export const useAsyncScript = (scriptSrc) => {
  const [isScriptLoading, isScriptLoadingError] = useScript({
    src: scriptSrc,
    checkForExisting: true,
  });
  const isScriptLoaded = !isScriptLoading && !isScriptLoadingError;

  return {
    isScriptLoading,
    isScriptLoadingError,
    isScriptLoaded,
  };
};
